<ng-container *ngIf="activeStep === 'basic_step'">
  <app-tdsp-conversion-pixel-basic
    [stepInput]="{
      globalParams: globalParams,
      isEdit: false,
      conversionPixel: conversionPixel
    }"
    (stepChange)="basicStepChange($event)"
  >
  </app-tdsp-conversion-pixel-basic>
</ng-container>
